export function makeUrl<P extends unknown, Q>(
    url: string,
    pathParams?: P,
    queryParams?: Q
): string {
    if (("" + url).indexOf("{") !== -1 && ("" + url).indexOf("}") !== -1) {
        return makeUrlGraph(url, pathParams, queryParams);
    } else {
        return makeUrlColon(url, pathParams, queryParams);
    }
}

export function makeUrlGraph<P extends unknown, Q>(
    url: string,
    pathParams?: P,
    queryParams?: Q
): string {
    let urlToReturn: string = `${url}`;

    if (pathParams) {
        for (const key in pathParams) {
            const regexp = new RegExp(`{${key}}`, "g");

            urlToReturn = urlToReturn.replace(regexp, (pathParams as any)[key]);
        }
    }

    if (queryParams) {
        urlToReturn += "?" + serialize(queryParams);
    }

    return urlToReturn;
}

export function makeUrlColon<P extends unknown, Q>(
    url: string,
    pathParams?: P,
    queryParams?: Q
): string {
    let urlToReturn: string = `${url}`;

    if (pathParams) {
        for (const key in pathParams) {
            const regexp = new RegExp(`:${key}`, "g");

            urlToReturn = urlToReturn.replace(regexp, (pathParams as any)[key]);
        }
    }

    if (queryParams) {
        urlToReturn += "?" + serialize(queryParams);
    }

    return urlToReturn;
}

export function serialize<B>(obj: B, prefix?: string): string {
    const str: Array<string> = [];
    let p: string;

    for (p in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, p)) {
            const key = prefix ? prefix + "[" + p + "]" : p;
            const value = (obj as any)[p];

            checkValue(value, key, str);
        }
    }

    return str.join("&");
}

const checkValue = (value: string | number | boolean | object, key: string, str: Array<string>) => {
    if (value !== null) {
        if (typeof value === "object") {
            const partialSerialize = serialize(value, key);

            if (partialSerialize.length > 0) {
                str.push(partialSerialize);
            }
        } else {
            str.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
        }
    }
};
